import { isNil } from 'lodash-es'
import React, { ReactElement } from 'react'

import { getFormatter } from '../../application/formBuilder'
import {
  TKeyBuilder,
  useWriskTranslation,
} from '../../infrastructure/internationalisation'
import { AdjustmentInputConfig, ChangeConfig } from '../../state/configuration'

type ExpandableSectionHeader = string | ReactElement
type ExpandableSectionResult = [ExpandableSectionHeader, AdjustmentInputConfig[]]

interface ExpandableSectionConfigProps<T> {
  sectionId: string
  inputs: AdjustmentInputConfig[]
  tKey: TKeyBuilder
  toData: (adjustment: ChangeConfig) => T
}

export const useExpandableSectionConfig = <T,>({
  sectionId,
  inputs,
  tKey,
  toData,
}: ExpandableSectionConfigProps<T>): ExpandableSectionResult => {
  const { t } = useWriskTranslation()

  const headerTranslation = t(tKey(sectionId), { defaultValue: null })

  const [firstInput, ...otherInputs] = inputs.filter(
    ({ adjustment, hidden }) => !isNil(toData(adjustment)) && !hidden,
  )

  const Formatter = getFormatter(firstInput.type)

  const header: ExpandableSectionHeader = headerTranslation ?? (
    <Formatter input={firstInput} value={toData(firstInput.adjustment)} t={t} />
  )

  const inputsToRender = headerTranslation ? [firstInput, ...otherInputs] : otherInputs

  return [header, inputsToRender]
}
